export default "__VITE_PUBLIC_ASSET__df7e5171__"